import * as $ from 'jquery';
import { IEventAggregator } from 'common/barrels/core';
import { DialogRequested } from 'runtime/events/dialogrequested';

export class DialogManager {
    private eventAggregator: IEventAggregator;

    constructor(eventAggregator: IEventAggregator) {
        this.eventAggregator = eventAggregator;

        this.eventAggregator.query(DialogRequested).subscribe(x => {
            var dc = x.dialog.content();

            const $container = $('.runtime-application-container');

            const containerWidth = !$container ? 300 : $container.width();
            const containerHeight = !$container ? 300 : $container.height();

            const width = Math.min((x.dialog.options.width > 0) ? x.dialog.options.width : 300, containerWidth - 8);

            const height = typeof x.dialog.options.height === 'number' && x.dialog.options.height > 0
                ? Math.min(x.dialog.options.height, containerHeight)
                : 'auto';

            dc.dialog({
                appendTo: '.runtime-application-container',
                buttons: x.dialog.options.buttons,
                dialogClass: (x.dialog.options.dialogClass) ? x.dialog.options.dialogClass : '',
                draggable: x.dialog.options.draggable || false,
                resizable: x.dialog.options.resizable || false,
                modal: x.dialog.options.modal || true,
                width: width,
                height: height,
                title: x.dialog.options.title,
                create: x.dialog.options.create,
                open: x.dialog.options.open,
                close: (event, ui) => {
                    if (x.dialog.options.close !== undefined && x.dialog.options.close !== null) {
                        x.dialog.options.close(event, ui);
                    }
                    dc.dialog('destroy');
                },
                resize: (event, ui) => {
                    if (x.dialog.options.resize !== undefined && x.dialog.options.resize !== null) {
                        x.dialog.options.resize(event, ui);
                    }
                }
            });
        });
    }
}